module.exports = __webpack_public_path__ + "static/1i-f1dcb8253031e839d164463115ce13bd.woff";